"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DishAddOnCategoryUpdateSchema = exports.DishAddOnCategoryUpdateScalarSchema = exports.DishAddOnCategoryCreateSchema = exports.DishAddOnCategoryCreateScalarSchema = exports.DishAddOnCategoryPrismaUpdateSchema = exports.DishAddOnCategoryPrismaCreateSchema = exports.DishAddOnCategorySchema = exports.DishAddOnCategoryScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const DishAddOnCategoryType_schema_1 = require("../enums/DishAddOnCategoryType.schema");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    nameEN: zod_1.z.string().min(1, { message: "Name must be between 1 and 100 characters" }).max(100, { message: "Name must be between 1 and 100 characters" }),
    nameFR: zod_1.z.string().min(1, { message: "Name must be between 1 and 100 characters" }).max(100, { message: "Name must be between 1 and 100 characters" }),
    type: DishAddOnCategoryType_schema_1.DishAddOnCategoryTypeSchema,
    displayOrder: zod_1.z.number().gte(0).default(0),
}).strict();
const relationSchema = zod_1.z.object({
    dishAddOns: zod_1.z.array(zod_1.z.unknown()).optional(),
    linkedDishes: zod_1.z.array(zod_1.z.unknown()).optional(),
    merchant: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    merchantId: zod_1.z.string().uuid(),
});
/**
 * `DishAddOnCategory` schema excluding foreign keys and relations.
 */
exports.DishAddOnCategoryScalarSchema = baseSchema;
/**
 * `DishAddOnCategory` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.DishAddOnCategorySchema = exports.DishAddOnCategoryScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.DishAddOnCategoryPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.DishAddOnCategoryPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    nameEN: zod_1.z.string().min(1, { message: "Name must be between 1 and 100 characters" }).max(100, { message: "Name must be between 1 and 100 characters" }),
    nameFR: zod_1.z.string().min(1, { message: "Name must be between 1 and 100 characters" }).max(100, { message: "Name must be between 1 and 100 characters" }),
    type: DishAddOnCategoryType_schema_1.DishAddOnCategoryTypeSchema,
    displayOrder: zod_1.z.union([zod_1.z.number().gte(0).default(0), zod_1.z.record(zod_1.z.unknown())])
}).partial().passthrough();
/**
 * `DishAddOnCategory` schema for create operations excluding foreign keys and relations.
 */
exports.DishAddOnCategoryCreateScalarSchema = baseSchema.partial({
    displayOrder: true
});
/**
 * `DishAddOnCategory` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.DishAddOnCategoryCreateSchema = exports.DishAddOnCategoryCreateScalarSchema.merge(fkSchema);
/**
 * `DishAddOnCategory` schema for update operations excluding foreign keys and relations.
 */
exports.DishAddOnCategoryUpdateScalarSchema = baseSchema.partial();
/**
 * `DishAddOnCategory` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.DishAddOnCategoryUpdateSchema = exports.DishAddOnCategoryUpdateScalarSchema.merge(fkSchema.partial());
